<h2 mat-dialog-title>{{'HISTORIAL_MAILS.MODAL.TITULO' | translate}}</h2>
<mat-dialog-content class="mat-typography">
  <div fxLayout="column" fxLayoutAlign="start stretch">
    <p>{{'HISTORIAL_MAILS.MODAL.SUBTITULO' | translate}}</p>
    <mat-form-field appearance="outline" fxFlex *ngIf="datos.tiposCorreos">
      <mat-label>{{'HISTORIAL_MAILS.MODAL.INPUT' | translate}}</mat-label>
      <mat-select [(ngModel)]="tipoCorreo">
        <mat-option *ngFor="let tipo of datos.tiposCorreos" [value]="tipo">
          {{'HISTORIAL_MAILS.MODAL.TIPOS.' + tipo | translate}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
    {{'HISTORIAL_MAILS.MODAL.BOTONES.BACK' | translate}}
    <mat-icon class="ml-20">arrow_back</mat-icon>
  </button>
  <button mat-raised-button color="primary" class="mt-20 ml-20 dialog_confirmar" (click)="eligeTipo()">
    {{'HISTORIAL_MAILS.MODAL.BOTONES.CONTINUAR' | translate}}
    <mat-icon class="ml-20">done</mat-icon>
  </button>
</div>
